import { SharePermissions } from '@sendent/nextcloud-api';
import { Builder } from '../helpers/builder';
import { UploadFile } from '../model';
import { store } from '../store';
import { selectFilesToUpload } from '../store/selectors/app';
import { ResolvedChatMember } from '../store/reducers/conversation/reducer';

export type ShareWithMembersData = {
    files: UploadFile[];
    permissions: SharePermissions;
    selectedMembers: ResolvedChatMember[];
};

export const getInitialMemberShareValues = (): ShareWithMembersData => {
    const state = store.getState();

    return Builder.of<ShareWithMembersData>()
        .addOrReplace('files', selectFilesToUpload(state))
        .addOrReplace('permissions', SharePermissions.Read)
        .addOrReplace('selectedMembers', [])
        .build();
};
